import React from "react";
import { Stack, TextField, Typography } from "@mui/material";

export default function TextInput({
  autoComplete,
  type,
  name,
  label,
  value,
  placeholder,
  handleChange,
  onPaste,
  onPasteCapture
}) {
  return (
    <Stack direction="column" gap="8px">
      <Typography variant="body2" color="secondary.main" fontWeight={500}>
        {label}
      </Typography>
      <TextField
        name={name}
        type={type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        onPaste={onPaste}
        onPasteCapture={onPasteCapture}
        autoComplete={autoComplete}
        required
      />
    </Stack>
  );
}
